import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { type UserPreferences, userPreferencesApi } from './user-preferences-api';

const KEY = ['user-preferences'] as const;

export function useUserPreferences() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => userPreferencesApi.get(),
    staleTime: 60_000,
  });
}

export function useUpdateUserPreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: UserPreferences) => userPreferencesApi.patch(patch),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data);
    },
  });
}
